<div
  class="upload-zone"
  [class.dragover]="dragging"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave()"
  (drop)="onDrop($event)"
  (click)="fileInput.click()"
>
  <input
    #fileInput
    type="file"
    accept=".xlsx,.xls,.csv"
    style="display:none"
    (change)="onFileChange($event)"
  />
  <div class="upload-icon">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" width="24" height="24">
      <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
      <polyline points="14 2 14 8 20 8"/>
    </svg>
  </div>
  <div class="upload-title">Drop your Excel or CSV file here</div>
  <div class="upload-hint">
    Supports <strong>.xlsx</strong>, <strong>.xls</strong>, and <strong>.csv</strong>
    &mdash; drag &amp; drop or click to browse
  </div>
</div>
